export const FETCH_LOV_REQUEST = "FETCH_LOV_REQUEST";
export const FETCH_LOV_SUCCESS = "FETCH_LOV_SUCCESS";
export const FETCH_LOV_FAILURE = "FETCH_LOV_FAILURE";
